import { render, staticRenderFns } from "./CoinsBundleCard.vue?vue&type=template&id=2bcea624&scoped=true&"
import script from "./CoinsBundleCard.vue?vue&type=script&lang=js&"
export * from "./CoinsBundleCard.vue?vue&type=script&lang=js&"
import style0 from "./CoinsBundleCard.vue?vue&type=style&index=0&id=2bcea624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcea624",
  null
  
)

export default component.exports